var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{on:{"~mousemove":function($event){return _vm.onMousemove.apply(null, arguments)},"~touch":function($event){return _vm.onTouch.apply(null, arguments)},"~focusin":function($event){return _vm.onFocus.apply(null, arguments)},"submit":_vm.onSubmit}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }